export default __webpack_public_path__ + "static/media/bajaj-blue.49b1a34e.png";